module.exports = __webpack_public_path__ + "static/media/icon_heb.fe9adaef.svg";